// extracted by mini-css-extract-plugin
export default {"container":"Trackers_container__E2jRz","header":"Trackers_header__qSR7A","image":"Trackers_image__Y998-","title":"Trackers_title__bcm9c","count":"Trackers_count__X5Lnw"};